import React, { useState, useEffect } from "react";
import { ReactComponent as Sun } from "./Sun.svg";
import { ReactComponent as Moon } from "./Moon.svg";
import "./DarkMode.css";

const SystemDefault = () => {
    const [darkMode, setDarkMode] = useState(
        localStorage.getItem("selectedColorTheme") === "dark"
    );

    const toggleTheme = () => {
        const newDarkMode = !darkMode;
        setDarkMode(newDarkMode);
        localStorage.setItem("selectedColorTheme", newDarkMode ? "dark" : "light");
    };

    useEffect(() => {
        const prefersDarkMode = window.matchMedia("(prefers-color-scheme: dark)");

        const handleChange = (e) => {
            setDarkMode(e.matches);
        };

        prefersDarkMode.addEventListener("change", handleChange);

        // Set the initial dark mode based on system preference
        setDarkMode(prefersDarkMode.matches);

        return () => {
            // Cleanup: Remove the event listener
            prefersDarkMode.removeEventListener("change", handleChange);
        };
    }, []);

    useEffect(() => {
        if (darkMode) {
            document.querySelector("body").setAttribute("data-theme2", "dark");
        } else {
            document.querySelector("body").setAttribute("data-theme2", "light");
        }
    }, [darkMode]);

    return (
        <div className="dark_mode d-none">
            <input
                className="dark_mode_input"
                type="checkbox"
                id="darkmode-toggle"
                onChange={toggleTheme}
                checked={darkMode}
            />
            <label className="dark_mode_label" htmlFor="darkmode-toggle">

            </label>
        </div>
    );
};

export default SystemDefault;
